const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!motionQuery.matches) {
  document.documentElement.classList.add('al-motion-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  document.querySelectorAll('[data-al-reveal]').forEach((element) => observer.observe(element));
}

function enhanceFinishLibrary(section) {
  const tabs = [...section.querySelectorAll('[data-al-finish-tab]')];
  const panels = [...section.querySelectorAll('[data-al-finish-panel]')];
  if (!tabs.length || !panels.length) return;

  section.classList.add('is-enhanced');

  const activate = (tab) => {
    const targetId = tab.getAttribute('aria-controls');
    tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
    panels.forEach((panel) => {
      panel.hidden = panel.id !== targetId;
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activate(tab));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const currentIndex = tabs.indexOf(tab);
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextTab = tabs[(currentIndex + direction + tabs.length) % tabs.length];
      nextTab.focus();
      activate(nextTab);
    });
  });

  activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
}

function enhanceLightComparison(section) {
  const stage = section.querySelector('[data-al-comparison-stage]');
  const range = section.querySelector('[data-al-comparison-range]');
  if (!stage || !range) return;

  const update = () => stage.style.setProperty('--al-compare', `${range.value}%`);
  range.addEventListener('input', update, { passive: true });
  update();
}

function enhanceProductCards(root = document) {
  root.querySelectorAll('[data-al-product-card]').forEach((card) => {
    const image = card.querySelector('.al-product-card__image');
    const originalSource = image?.currentSrc || image?.src;
    const originalSourceSet = image?.getAttribute('srcset');
    if (!image || !originalSource) return;

    card.querySelectorAll('[data-al-variant-image]').forEach((swatch) => {
      const preview = () => {
        const source = swatch.dataset.alVariantImage;
        if (!source) return;
        image.removeAttribute('srcset');
        image.src = source;
      };
      swatch.addEventListener('pointerenter', preview);
      swatch.addEventListener('focus', preview);
    });

    card.addEventListener('pointerleave', () => {
      image.src = originalSource;
      if (originalSourceSet) image.setAttribute('srcset', originalSourceSet);
    });
  });
}

function enhanceAnLights(root = document) {
  root.querySelectorAll('[data-al-finishes]').forEach(enhanceFinishLibrary);
  root.querySelectorAll('[data-al-light-in-space]').forEach(enhanceLightComparison);
  enhanceProductCards(root);
}

enhanceAnLights();

document.addEventListener('shopify:section:load', (event) => enhanceAnLights(event.target));
